import Flex from 'components/Flex/Flex';

export default Flex;
